<template>
    <div class="view">
        <BackButton routeName="appointment-list"/>

        <div class="inner-content full" v-if="shop != null">
            <h1>{{$t('hours.title')}} {{this.shop.name}}</h1>

            <div class="slots">
                <div v-for="slot, i in slots" :key="slot.id" class="slot">
                    <div class="slot--header">
                        {{$t('hours.'+labels[i])}}
                    </div>
                    <div>
                        <div v-for="hours, i in slot" :key="hours.id" class="slot--hours">
                            <button @click.prevent="removeHours(slot, i)" class="btn">-</button>
                            <input v-model="hours.from" :class="{error : !isValid(hours.from)}">
                            <div class="slot--minus">-</div>
                            <input v-model="hours.to" :class="{error : !isValid(hours.to)}">
                        </div>
                        <div v-if="slot.length == 0">
                            {{$t('shop_settings.closed')}}
                        </div>
                        <div class="add-btn">
                            <a href="#" @click.prevent="addHours(slot)">{{$t('shop_settings.add_row')}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="slot-duration">
                {{$t('shop_settings.slot_info')}} : <input type="number" v-model="slotDuration" />
            </div>

            <div class="print-setting">
				<Checkbox v-model:checked="shop.auto_print" :label="$t('shop_settings.auto_print')"/>
            </div>

            <div class="bottom">
                <button class="btn-basic blue" @click.prevent="saveHours">{{$t('generic.save')}}</button>
                <div v-if="feedback" class="feedback">
                    {{$t('shop_settings.feedback')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import Checkbox from "@/components/Checkbox.vue";
import LoginMixin from "@/mixins/LoginMixin";
import {apiStore} from "@/stores/api.js";

export default {
    name : "ShopSettings",
    components: {
        BackButton,
        Checkbox
    },
    mixins : [LoginMixin],

    data() {
        return {
            labels : [
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday"
            ],
            shop : null,
            slots : null,
            feedback : false,
            slotDuration : 0
        };
    },

    async created() {
        this.shop = await apiStore().getShop(this.loggedInUser.shop.id);
        const json = JSON.parse(this.shop.hours);
        this.slots = json.slots;
        this.slotDuration = json.duration;
    },

    methods: {
        addHours(slot) {
            slot.push({from:"", to:""});
        },

        removeHours(slot, position) {
            slot.splice(position, 1);
        },

        isValid(hour) {
            return /^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/.test(hour);
        },

        async saveHours() {
            this.feedback = false;
            const hasError = this.slots.flat().some(x => !this.isValid(x.to) || !this.isValid(x.from));

            if (!hasError) {
                const hours = {
                    slots : this.slots,
                    duration : parseInt(this.slotDuration)
                };
                const data = {
                    id : this.loggedInUser.shop.id,
                    auto_print : this.shop.auto_print,
                    hours : JSON.stringify(hours)
                };
                await apiStore().updateShop(data);

                this.feedback = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>

    .inner-content {
        padding-top: 2%;

        h1 {
            margin-left: 5%;
        }
    }

    .view {
        position: relative;

        h1 {
            padding-bottom: 1rem;
        }

        .slots {
            display : flex;
            justify-content: flex-start;
            width: 100%;
            text-align: center;
            flex-wrap: wrap;

            .slot {
                width: 25%;
                padding: 1rem;
                border: solid 1px #ddd;

                &--header {
                    font-weight: bold;
                    margin-bottom : 1rem;
                }

                &--hours {
                    display : flex;
                    align-items: stretch;
                    margin-bottom: .5rem;

                    input {
                        width : 40%;
                        height : 2rem;
                        font-size: 1.25em;
                        border : solid .1rem $color-blue;
                        text-align : center;
                        border-radius: 0;

                        &.error {
                            border-color : $color-red;
                        }
                    }
                }

                &--minus {
                    margin : 0 .35rem;
                    padding-top: 0.6rem;
                }
            }
        }

        .add-btn {
            margin-top : 1rem;
            text-align : center;
        }

        .slot-duration {
            margin-top : 2rem;

             input {
                width : 5rem;
                font-size: 1.25em;
                border : solid .1rem $color-blue;
                text-align : left;
            }
        }

        .feedback {
            color : $color-green;
            font-size: 1.2em;
            margin-left : 1.2rem;
        }

        .btn {
            @extend .reset-btn;
            background : $color-blue;
            width : 2rem;
            height : 2rem;
            font-size : 1.35em;
            color : white;
            margin-right : .25rem;
            padding : 0;
        }

        .bottom {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .print-setting {
            margin-top : 2rem;
            margin-bottom : 2rem;
        }
    }
</style>